module.exports = __webpack_public_path__ + "static/nkbm-ba110c6759bf41648fbaa40caf7f9a44.png";